import { ENV } from 'constants/env'
import { IBookingDetail, IPatient } from 'pages/patientReceive/interfaces'
import io from 'socket.io-client'

export enum ESocketEventName {
  MANAGE_PATIENT_TOPIC = 'MANAGE_PATIENT_TOPIC_',
  MANAGE_PATIENT_DELETE_TOPIC = 'MANAGE_PATIENT_DELETE_TOPIC_',
  MANAGE_BOOKING_TOPIC = 'MANAGE_BOOKING_TOPIC_',
  MANAGE_BOOKING_UPDATE_TOPIC = 'MANAGE_BOOKING_UPDATE_TOPIC_',
  MANAGE_BOOKING_UPDATE_STATUS_TOPIC = 'MANAGE_BOOKING_UPDATE_STATUS_TOPIC_',
  MANAGE_PATIENT_ADD_TOPIC = 'MANAGE_PATIENT_ADD_TOPIC_',
  MANAGE_NOTIFICATION_TOPIC = 'MANAGE_NOTIFICATION_TOPIC_',
  MANAGE_NOTIFICATION_TOPIC_ALL_CLINIC = 'all_clinic'
}

class SocketIoService {
  private _connection: any | null = null
  private _eventsWaitingEmit: Array<{
    eventName: string
    dataCallback: (data: any) => void
  }> = []

  _subscribeEvent(eventName: string, dataCallback: (data: any) => void) {
    if (eventName !== ESocketEventName.MANAGE_NOTIFICATION_TOPIC_ALL_CLINIC) {
      eventName += localStorage.getItem('userIdOfClinic') || ''
    }
    // console.log(eventName)
    if (!this._connection) {
      this._eventsWaitingEmit.push({
        eventName,
        dataCallback
      })
    }
    this._connection?.emit(eventName)
    this._connection?.on(eventName, (data: any) =>
      dataCallback(this._handlerDataSocket(data))
    )
  }

  _handlerDataSocket(data: any) {
    try {
      return JSON.parse(data)
    } catch (error) {
      return undefined
    }
  }

  initSocket() {
    this._connection = io(ENV.socket, {
      transports: ['websocket'],
      reconnection: true,
      autoConnect: true
    })
    this._eventsWaitingEmit?.forEach((eventWaiting) => {
      this._subscribeEvent(eventWaiting.eventName, eventWaiting.dataCallback)
    })
  }

  getSocketConnection() {
    return this._connection
  }

  subscribeCreateBooking(dataCallback: (booking: IBookingDetail) => void) {
    const eventName = ESocketEventName.MANAGE_BOOKING_TOPIC
    this._subscribeEvent(eventName, dataCallback)
  }

  subscribeCreatePatient(dataCallback: (patient: IPatient) => void) {
    const eventName = ESocketEventName.MANAGE_PATIENT_TOPIC
    this._subscribeEvent(eventName, dataCallback)
  }

  subscribeCreatePatientFromMobile(dataCallback: (patient: IPatient) => void) {
    const eventName = ESocketEventName.MANAGE_PATIENT_ADD_TOPIC
    this._subscribeEvent(eventName, dataCallback)
  }

  subscribeDeletePatient(dataCallback: (idPatient: number) => void) {
    const eventName = ESocketEventName.MANAGE_PATIENT_DELETE_TOPIC
    this._subscribeEvent(eventName, dataCallback)
  }

  subscribeUpdateBooking(dataCallback: (booking: IBookingDetail) => void) {
    const eventName = ESocketEventName.MANAGE_BOOKING_UPDATE_TOPIC
    this._subscribeEvent(eventName, dataCallback)
  }

  subscribeBookingUpdateStatus(
    dataCallback: (booking: IBookingDetail) => void
  ) {
    const eventName = ESocketEventName.MANAGE_BOOKING_UPDATE_STATUS_TOPIC
    this._subscribeEvent(eventName, dataCallback)
  }

  subscribeNotification(dataCallback: (notification: any) => void) {
    const eventName = ESocketEventName.MANAGE_NOTIFICATION_TOPIC
    this._subscribeEvent(eventName, dataCallback)
  }

  subscribeAllClinicNotification(dataCallback: (notification: any) => void) {
    const eventName = ESocketEventName.MANAGE_NOTIFICATION_TOPIC_ALL_CLINIC
    this._subscribeEvent(eventName, dataCallback)
  }

  unsubscribeEvent(eventName: ESocketEventName) {
    if (this._connection) {
      const fullEventName = eventName + localStorage.getItem('userIdOfClinic')
      this._connection?.off(fullEventName)
      this._connection?.off(eventName)
    }
  }
}

export const socketIoService = new SocketIoService()
